import type { IDescriptions } from './types'
import {
  getEmptyDescriptionsTemplate,
  convertDescriptionResponseToObject,
  getDescriptionsApi,
} from './utils'
import type { IGetDescriptionsRequestParams } from './types'

export const fetchVehicleDescription = async (
  params: IGetDescriptionsRequestParams,
): Promise<IDescriptions> => {
  const apiUrl = getDescriptionsApi()
  const path = 'get-descriptions'

  const accountId = params.accountId
  const vin = params.vin
  const query = `accountId=${accountId}&vin=${vin}`

  let descriptions = getEmptyDescriptionsTemplate()

  try {
    const response = await fetch(`${apiUrl}/${path}?${query}`, {
      method: 'GET',
    })

    const responseJson = await response.json()
    descriptions = convertDescriptionResponseToObject(responseJson)
  } catch (error) {
    console.error('Error fetching API endpoint:', error)
    throw error
  }

  return descriptions
}
